import { Tooltip } from '@frontend/legacy-components';
import { utils } from '@frontend/partviewer';
import type { UNITS } from '@frontend/partviewer/src/constants';

import {
  DisplayWrapper,
  DisplayTitle,
  DisplayEntry,
  DisplayEntryWrapper,
} from 'modules/common/viewer/components/ViewerDisplayElements';

import { formatFloat } from 'utils/formatters';

const { formatLengthProp } = utils;

type MeasurementComparisonComponentProps = {
  comparison: {
    angle: number;
    resolution: string;
    type: string;
  };
  currentMeasurementValue: number | null;
  displayScale: number;
  displayUnits: UNITS;
  nativeUnits: UNITS;
  dimensionalPrecision: number;
};

const MeasurementComparisonComponent = ({
  comparison,
  currentMeasurementValue,
  displayScale,
  displayUnits,
  nativeUnits,
  dimensionalPrecision,
}: MeasurementComparisonComponentProps) => {
  return comparison && currentMeasurementValue !== null ? (
    <DisplayWrapper>
      <DisplayTitle>Measurement</DisplayTitle>
      <DisplayEntryWrapper>
        <DisplayEntry>Distance:</DisplayEntry>
        <DisplayEntry>
          {formatLengthProp({
            value: currentMeasurementValue,
            order: 1,
            displayUnits,
            nativeUnits,
            dimensionalPrecision,
            displayScale,
          })}
        </DisplayEntry>
      </DisplayEntryWrapper>
      <Tooltip placement="bottom" label={`Type: ${comparison.type}`}>
        <DisplayEntryWrapper>
          <DisplayEntry>Angle</DisplayEntry>
          {comparison.resolution ? (
            <DisplayEntry>{`${formatFloat(
              (comparison.angle * 180) / Math.PI,
              3,
            )}\u00b0 (${comparison.resolution})`}</DisplayEntry>
          ) : (
            <DisplayEntry>{`${formatFloat(
              (comparison.angle * 180) / Math.PI,
              3,
            )}\u00b0`}</DisplayEntry>
          )}
        </DisplayEntryWrapper>
      </Tooltip>
    </DisplayWrapper>
  ) : null;
};

export default MeasurementComparisonComponent;
